import { ADMISSION_TYPE_BOTTLE_SERVICE, ADMISSION_TYPE_GUEST_LIST } from '@domain/admission';
import { type TFunction } from 'i18next';

import { type AdmissionFlow, type AdmissionFormMode, type AdmissionFormType } from './admission-form.type';
import { ADMISSION_FORM_FLOW_PRESET, ADMISSION_FORM_MODE_CREATE, ADMISSION_FORM_TYPE_PASS } from './constants';

const subjectKey = (flow: AdmissionFlow, type: AdmissionFormType): string => {
  // A pass is always titled "pass" — even in the preset flow (a preset pass is still a pass, whereas
  // preset ticket/bottle/guest-list forms read as the generic "preset").
  if (type === ADMISSION_FORM_TYPE_PASS) return 'common:seasonPassLabel';
  if (flow === ADMISSION_FORM_FLOW_PRESET) return 'offers:admissionFormSubjectPreset';

  switch (type) {
    case ADMISSION_TYPE_BOTTLE_SERVICE:
      return 'common:bottleServiceLabel';
    case ADMISSION_TYPE_GUEST_LIST:
      return 'common:guestListLabel';
    default:
      return 'common:ticketLabel';
  }
};

const toSentenceCase = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const getFormTitle = (
  t: TFunction,
  mode: AdmissionFormMode,
  flow: AdmissionFlow,
  type: AdmissionFormType
): string =>
  toSentenceCase(
    t(mode === ADMISSION_FORM_MODE_CREATE ? 'offers:admissionFormTitleCreate' : 'offers:admissionFormTitleEdit', {
      subject: t(subjectKey(flow, type)),
    })
  );

export const getSubmitLabel = (t: TFunction, mode: AdmissionFormMode): string =>
  t(mode === ADMISSION_FORM_MODE_CREATE ? 'common:create' : 'common:save');
